document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    if (typeof window.jQuery !== "undefined") {
        initializeCustomReviews(window.jQuery);
        return;
    }

    var jqueryScript = document.createElement("script");
    jqueryScript.src = "https://code.jquery.com/jquery-3.7.1.min.js";
    jqueryScript.onload = function () {
        initializeCustomReviews(window.jQuery);
    };
    jqueryScript.onerror = function () {
        console.error("Custom Reviews: jQuery could not be loaded.");
    };
    document.head.appendChild(jqueryScript);
});

function initializeCustomReviews($) {
    "use strict";

        $(".cr-section").each(function () {
            var $section = $(this);
            var $grid = $section.find(".cr-grid");
            var $gallery = $section.find(".cr-gallery");
            var $loader = $section.find(".cr-loader");
            var $empty = $section.find(".cr-empty");
            var $loadMore = $section.find(".cr-loadmore");
            var $average = $section.find(".cr-average, .cr-average-rating");
            var $total = $section.find(".cr-total, .cr-total-reviews");
            var $filterTarget = $section.find(".cr-rating-filter");
            var $sortTarget = $section.find(".cr-sort-dropdown");
            var config = {
                shopDomain: ($section.find("#cr-shop-domain").val() || "").trim(),
                apiToken: ($section.find("#cr-api-token").val() || "").trim(),
                perPage: Number($section.find("#cr-per-page").val()) || 12,
                apiUrl: "https://api.judge.me/api/v1/widgets/all_reviews_page"
            };
            var state = {
                allReviews: [],
                filteredReviews: [],
                gallery: [],
                rendered: 0,
                filter: "all",
                sort: "newest",
                page: 1,
                loading: false,
                lastPageKey: ""
            };

            if (!config.shopDomain || !config.apiToken) {
                showError("Reviews are not configured yet.");
                return;
            }

            buildControls();
            bindEvents();
            fetchReviews();

            function bindEvents() {
                $section.on("click", ".cr-filter-chip", function () {
                    var selectedFilter = String($(this).data("filter"));
                    state.filter = state.filter === selectedFilter ? "all" : selectedFilter;
                    $section.find(".cr-filter-chip").removeClass("active");
                    if (state.filter !== "all") $(this).addClass("active");
                    applyFilterAndSort();
                });

                $section.on("click", ".cr-clear-filters", function () {
                    state.filter = "all";
                    $section.find(".cr-filter-chip").removeClass("active");
                    applyFilterAndSort();
                });

                $section.on("change", ".cr-sort-select", function () {
                    state.sort = $(this).val();
                    applyFilterAndSort();
                });

                $section.on("click", ".cr-sort-option", function () {
                    state.sort = String($(this).data("sort"));
                    $section.find(".cr-sort-option").removeClass("active");
                    $(this).addClass("active");
                    $sortTarget.removeClass("is-open");
                    applyFilterAndSort();
                });

                $section.find(".cr-filter-btn").on("click", function () {
                    $section.find(".cr-toolbar").toggleClass("is-open");
                });

                $section.find(".cr-sort-btn").on("click", function () {
                    $sortTarget.toggleClass("is-open");
                    $sortTarget.find(".cr-sort-select").trigger("focus");
                });

                $loadMore.on("click", function () {
                    renderReviews(false);
                });

                $section.on("click", ".cr-media img", function () {
                    var reviewId = Number($(this).closest(".cr-card").data("reviewIndex"));
                    var review = state.allReviews.filter(function (item) { return item._crId === reviewId; })[0];
                    if (review) openReviewModal(review, $(this).data("full") || $(this).attr("src"));
                });

                $section.on("click", ".cr-gallery-item img", function () {
                    var reviewId = Number($(this).closest(".cr-gallery-item").data("reviewIndex"));
                    var review = state.allReviews.filter(function (item) { return item._crId === reviewId; })[0];
                    if (review) openReviewModal(review, $(this).data("full") || $(this).attr("src"));
                });

                $section.find(".cr-gallery-prev, .cr-gallery-next").on("click", function () {
                    var gallery = $gallery.get(0);
                    if (!gallery) return;
                    gallery.scrollBy({ left: ($(this).hasClass("cr-gallery-next") ? 1 : -1) * Math.max(gallery.clientWidth * 0.7, 220), behavior: "smooth" });
                });

                $section.on("click", ".cr-card", function (event) {
                    if ($(event.target).closest("button, a, img").length) return;
                    var reviewId = Number($(this).data("reviewIndex"));
                    var review = state.allReviews.filter(function (item) { return item._crId === reviewId; })[0];
                    if (review) openReviewModal(review);
                });
            }

            function fetchReviews() {
                state.allReviews = [];
                state.page = 1;
                state.lastPageKey = "";
                state.loading = true;
                $grid.empty();
                $empty.hide();
                $loadMore.hide();
                $loader.stop(true, true).fadeIn(150);
                fetchPage();
            }

            function fetchPage() {
                $.ajax({
                    url: config.apiUrl,
                    method: "GET",
                    dataType: "json",
                    data: {
                        shop_domain: config.shopDomain,
                        api_token: config.apiToken,
                        page: state.page,
                        per_page: 100,
                        published: true
                    }
                }).done(function (response) {
                    var reviews = response && Array.isArray(response.reviews) ? response.reviews : parseWidgetReviews(response && response.all_reviews);
                    var pageKey = reviews.map(function (review) { return [review.id, review.created_at, review.title, review.body].join("|"); }).join("~");
                    if (state.page > 1 && pageKey && pageKey === state.lastPageKey) {
                        finishLoading();
                        return;
                    }
                    state.lastPageKey = pageKey;
                    state.allReviews = state.allReviews.concat(reviews);

                    if (hasNextPage(response, reviews.length)) {
                        state.page += 1;
                        fetchPage();
                        return;
                    }
                    finishLoading();
                }).fail(function () {
                    state.loading = false;
                    $loader.hide();
                    showError("Unable to load reviews. Please try again later.");
                });
            }

            function hasNextPage(response, count) {
                if (response && Number(response.current_page) && Number(response.total_pages)) {
                    return Number(response.current_page) < Number(response.total_pages);
                }
                if (response && response.pagination && Number(response.pagination.current_page) && Number(response.pagination.total_pages)) {
                    return Number(response.pagination.current_page) < Number(response.pagination.total_pages);
                }
                return count >= 25 && state.page < 100;
            }

            function parseWidgetReviews(html) {
                if (!html) return [];
                var documentNode = new DOMParser().parseFromString(html, "text/html");
                return Array.prototype.map.call(documentNode.querySelectorAll(".jdgm-rev"), function (node) {
                    var pictureNodes = node.querySelectorAll(".jdgm-rev__pic-img");
                    return {
                        rating: node.querySelectorAll(".jdgm-star.jdgm--on").length || text(node, ".jdgm-rev__rating").match(/\d/)?.[0] || 0,
                        reviewer: { name: text(node, ".jdgm-rev__author") || "Customer" },
                        title: text(node, ".jdgm-rev__title"),
                        body: text(node, ".jdgm-rev__body"),
                        product_title: text(node, ".jdgm-rev__prod-link"),
                        product_handle: productHandle(node),
                        created_at: dateValue(node),
                        verified: node.classList.contains("jdgm-rev--verified") || !!node.querySelector(".jdgm-rev__buyer-badge"),
                        pictures: Array.prototype.map.call(pictureNodes, function (image) {
                            var src = image.getAttribute("data-src") || image.getAttribute("src") || "";
                            return { urls: { compact: src, huge: src, original: src } };
                        }).filter(function (picture) { return picture.urls.compact; })
                    };
                });
            }

            function text(node, selector) {
                var element = node.querySelector(selector);
                return element ? element.textContent.trim() : "";
            }

            function productHandle(node) {
                var link = node.querySelector(".jdgm-rev__prod-link");
                var match = link && link.getAttribute("href") && link.getAttribute("href").match(/\/products\/([^?#/]+)/);
                return match ? match[1] : "";
            }

            function dateValue(node) {
                var date = node.querySelector(".jdgm-rev__timestamp, time");
                return date ? (date.getAttribute("data-content") || date.getAttribute("datetime") || date.textContent.trim()) : "";
            }

            function finishLoading() {
                state.loading = false;
                $loader.hide();
                state.allReviews = uniqueReviews(state.allReviews);
                state.allReviews.forEach(function (review, index) { review._crId = index; });
                updateSummary();
                buildGallery();
                applyFilterAndSort();
            }

            function uniqueReviews(reviews) {
                var seen = {};
                return reviews.filter(function (review) {
                    var key = [review.id, review.created_at, review.title, review.body, review.reviewer && review.reviewer.name].join("|");
                    if (seen[key]) return false;
                    seen[key] = true;
                    return true;
                });
            }

            function updateSummary() {
                var count = state.allReviews.length;
                var total = state.allReviews.reduce(function (sum, review) { return sum + Number(review.rating || 0); }, 0);
                $average.text(count ? (total / count).toFixed(1) : "0.0");
                $total.text(count + " " + (count === 1 ? "Review" : "Reviews"));
                updateFilterCounts();
            }

            function buildControls() {
                var filters = [["1", "1"], ["2", "2"], ["3", "3"], ["4", "4"], ["5", "5"]];
                $filterTarget.html(filters.map(function (item, index) {
                    return '<button type="button" class="cr-filter-chip" data-filter="' + item[0] + '" aria-label="Show ' + item[1] + ' star reviews">' + item[1] + '&#9733;</button>';
                }).join(""));
                var sortOptions = [["newest", "Most recent"], ["highest", "Highest rating"], ["lowest", "Lowest rating"], ["photo", "Only pictures"], ["pictures-first", "Pictures first"], ["videos-first", "Videos first"], ["helpful", "Most helpful"]];
                $sortTarget.html('<div class="cr-sort-menu">' + sortOptions.map(function (option, index) {
                    return '<button type="button" class="cr-sort-option' + (index === 0 ? " active" : "") + '" data-sort="' + option[0] + '">' + option[1] + '</button>';
                }).join("") + "</div>");
            }

            function updateFilterCounts() {
                $section.find(".cr-filter-chip").each(function () {
                    var filter = String($(this).data("filter"));
                    var count = filter === "all" ? state.allReviews.length : state.allReviews.filter(function (review) {
                        return filter === "photo" ? picturesOf(review).length > 0 : Number(review.rating) === Number(filter);
                    }).length;
                    $(this).find(".cr-filter-count").text("(" + count + ")");
                });
            }

            function applyFilterAndSort() {
                state.filteredReviews = state.allReviews.filter(function (review) {
                    return state.filter === "all" || (state.filter === "photo" ? picturesOf(review).length > 0 : Number(review.rating) === Number(state.filter));
                });
                if (state.sort === "photo") {
                    state.filteredReviews = state.filteredReviews.filter(function (review) {
                        return picturesOf(review).length > 0;
                    });
                }
                state.filteredReviews.sort(function (a, b) {
                    if (state.sort === "pictures-first") return picturesOf(b).length - picturesOf(a).length;
                    if (state.sort === "videos-first" || state.sort === "helpful") return 0;
                    if (state.sort === "highest") return Number(b.rating) - Number(a.rating);
                    if (state.sort === "lowest") return Number(a.rating) - Number(b.rating);
                    var difference = new Date(a.created_at || 0) - new Date(b.created_at || 0);
                    return state.sort === "oldest" ? difference : -difference;
                });
                renderReviews(true);
            }

            function renderReviews(reset) {
                if (reset) {
                    state.rendered = 0;
                    $grid.empty();
                }
                var reviews = state.filteredReviews.slice(state.rendered, state.rendered + config.perPage);
                if (!reviews.length && !state.rendered) {
                    $empty.show().html("<h3>No reviews found</h3><p>Try another filter.</p>");
                } else {
                    $empty.hide();
                    reviews.forEach(function (review) { $grid.append(reviewCard(review)); });
                    state.rendered += reviews.length;
                }
                $loadMore.toggle(state.rendered < state.filteredReviews.length);
            }

            function reviewCard(review) {
                var reviewer = review.reviewer && review.reviewer.name ? review.reviewer.name : "Customer";
                var html = '<article class="cr-card" data-review-index="' + review._crId + '"><div class="cr-card-body">';
                html += stars(review.rating);
                html += '<div class="cr-author-row"><span class="cr-author">' + escapeHtml(reviewer) + '</span><span class="cr-verified">Verified</span></div>';
                html += '<time class="cr-date">' + formatDate(review.created_at) + '</time>';
                if (review.title) html += '<div class="cr-review-title">' + escapeHtml(review.title) + '</div>';
                if (review.body) html += '<div class="cr-review-body">' + nl2br(escapeHtml(review.body)) + '</div>';
                html += media(review);
                return html + '</div></article>';
            }

            function stars(rating) {
                var value = Number(rating) || 0;
                var html = '<div class="cr-stars" aria-label="' + value + ' out of 5 stars">';
                for (var i = 1; i <= 5; i += 1) html += '<span>' + (i <= value ? '&#9733;' : '&#9734;') + '</span>';
                return html + "</div>";
            }

            function media(review) {
                var pictures = picturesOf(review);
                if (!pictures.length) return "";
                return '<div class="cr-media">' + pictures.slice(0, 6).map(function (picture) {
                    return '<button type="button" class="cr-media-item"><img src="' + escapeAttribute(picture.compact) + '" data-full="' + escapeAttribute(picture.original) + '" alt="Customer review photo" loading="lazy"></button>';
                }).join("") + "</div>";
            }

            function picturesOf(review) {
                return (review.pictures || []).map(function (picture) {
                    var urls = picture.urls || picture;
                    var source = urls.original || urls.huge || urls.large || urls.compact || urls.small || urls.url || "";
                    return { compact: urls.compact || urls.small || source, original: source };
                }).filter(function (picture) { return picture.compact; });
            }

            function buildGallery() {
                state.gallery = [];
                state.allReviews.forEach(function (review) {
                    picturesOf(review).forEach(function (picture) {
                        picture.reviewId = review._crId;
                        state.gallery.push(picture);
                    });
                });
                if (!state.gallery.length) {
                    $gallery.hide().empty();
                    return;
                }
                $gallery.html(state.gallery.slice(0, 18).map(function (picture) {
                    return '<button type="button" class="cr-gallery-item" data-review-index="' + picture.reviewId + '"><img src="' + escapeAttribute(picture.compact) + '" data-full="' + escapeAttribute(picture.original) + '" alt="Customer review photo" loading="lazy"></button>';
                }).join("")).show();
            }

            function openReviewModal(review, selectedImage) {
                var pictures = picturesOf(review);
                var reviewer = review.reviewer && review.reviewer.name ? review.reviewer.name : "Customer";
                var $modal = $("#cr-review-modal");
                var pictureIndex = Math.max(0, pictures.findIndex(function (picture) { return picture.original === selectedImage || picture.compact === selectedImage; }));

                if (!$modal.length) {
                    $modal = $('<div id="cr-review-modal" class="cr-review-modal" role="dialog" aria-modal="true"><div class="cr-review-modal-panel"></div></div>');
                    $("body").append($modal);
                    $modal.on("click", function (event) {
                        if (event.target === this || $(event.target).closest(".cr-review-modal-close").length) $modal.removeClass("active");
                    });
                    $(document).on("keyup", function (event) {
                        if (event.key === "Escape") $("#cr-review-modal").removeClass("active");
                    });
                }

                function renderModal() {
                    var html = '<button type="button" class="cr-review-modal-close" aria-label="Close">&times;</button>';
                    if (pictures.length) {
                        html += '<div class="cr-review-modal-media"><img src="' + escapeAttribute(pictures[pictureIndex].original) + '" alt="Customer review photo">';
                        if (pictures.length > 1) html += '<button type="button" class="cr-review-modal-prev" aria-label="Previous photo">&#8249;</button><button type="button" class="cr-review-modal-next" aria-label="Next photo">&#8250;</button>';
                        html += '</div>';
                    }
                    html += '<div class="cr-review-modal-content">' + stars(review.rating);
                    html += '<div class="cr-review-modal-author"><span class="cr-review-modal-avatar">' + escapeHtml(reviewer.charAt(0).toUpperCase()) + '</span><div><div><strong>' + escapeHtml(reviewer) + '</strong> <span class="cr-verified">Verified</span></div><time class="cr-date">' + formatDate(review.created_at) + '</time></div></div>';
                    if (review.title) html += '<h3>' + escapeHtml(review.title) + '</h3>';
                    if (review.body) html += '<div class="cr-review-modal-body">' + nl2br(escapeHtml(review.body)) + '</div>';
                    $modal.find(".cr-review-modal-panel").html(html);
                    $modal.toggleClass("has-media", pictures.length > 0).addClass("active");
                }

                renderModal();
                $modal.off("click.reviewNavigation").on("click.reviewNavigation", ".cr-review-modal-prev, .cr-review-modal-next", function (event) {
                    event.stopPropagation();
                    pictureIndex = $(this).hasClass("cr-review-modal-next") ? (pictureIndex + 1) % pictures.length : (pictureIndex + pictures.length - 1) % pictures.length;
                    renderModal();
                });
            }

            function showError(message) {
                $loader.hide();
                $empty.show().html("<h3>Reviews unavailable</h3><p>" + escapeHtml(message) + "</p>");
            }

            function formatDate(value) {
                var date = new Date(value);
                return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
            }

            function escapeHtml(value) {
                return $("<div>").text(value == null ? "" : value).html();
            }

            function escapeAttribute(value) {
                return escapeHtml(value).replace(/"/g, "&quot;");
            }

            function nl2br(value) {
                return value.replace(/\r?\n/g, "<br>");
            }

            window.CustomReviews = window.CustomReviews || {};
            window.CustomReviews.reload = fetchReviews;
        });

        function openLightbox(source) {
            if (!source) return;
            var $lightbox = $("#cr-lightbox");
            if (!$lightbox.length) {
                $lightbox = $('<div id="cr-lightbox" class="cr-lightbox" role="dialog" aria-modal="true" aria-label="Review photo"><button type="button" class="cr-lightbox-close" aria-label="Close">&times;</button><img alt="Customer review photo"></div>');
                $("body").append($lightbox);
                $lightbox.on("click", function (event) {
                    if (event.target === this || $(event.target).hasClass("cr-lightbox-close")) $lightbox.removeClass("active");
                });
                $(document).on("keyup", function (event) {
                    if (event.key === "Escape") $("#cr-lightbox").removeClass("active");
                });
            }
            $lightbox.find("img").attr("src", source);
            $lightbox.addClass("active");
        }
}
